"use client";

import BFLButton from "@repo/shared-ui/BFLButton";
import BFLModal from "@repo/shared-ui/BFLModal";
import useModalCloseOnBrowserButton from "@repo/shared-ui/useModalCloseOnBrowserButton";
import React, { FC } from "react";

export function formatFilterModalTitle(title: string, selectedCount: number): string {
  if (selectedCount > 0) {
    return `${title} - ${selectedCount} selected`;
  }
  return title;
}

interface FilterModalProps {
  isOpen: boolean;
  title: string;
  selectedCount: number;
  onClose: () => void;
  onClear: () => void;
  onApply: () => void;
  clearText: string;
  applyText: string;
  closeAriaLabel: string;
  children: React.ReactNode;
}

const FilterModal: FC<FilterModalProps> = ({
  isOpen,
  title,
  selectedCount,
  onClose,
  onClear,
  onApply,
  clearText,
  applyText,
  closeAriaLabel,
  children,
}) => {
  useModalCloseOnBrowserButton(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <BFLModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      showHeader={false}
      enableScroll
      modalClassName="pointer-events-none items-end justify-center md:hidden"
      contentClassName="w-full rounded-t-lg"
      bodyClassName="pointer-events-auto"
      contentWrapperClassName="px-0"
      footerClassName="hidden"
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between h-[56px] px-3 py-[19px] border-b border-[#d2d2d2] rounded-t-[4px] bg-gray-200">
          <div className="text-[14px] font-medium text-[#1A1A1A]">
            {formatFilterModalTitle(title, selectedCount)}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100"
            aria-label={closeAriaLabel}
          >
            <i
              className="icomoon text-[10px] text-gray-900 before:content-['\e914']"
              aria-hidden="true"
            />
          </button>
        </div>

        {children}

        <div className="flex items-center justify-between gap-3 px-[20px] py-4 border-t border-[#d2d2d2] bg-white z-2">
          <button
            type="button"
            onClick={onClear}
            className="text-[14px] font-medium text-[rgb(255,103,0)]"
          >
            {clearText}
          </button>
          <div className="flex-1" />
          <div className="w-[45%]">
            <BFLButton
              type="button"
              onClick={onApply}
              className="w-full rounded-[20px] bg-[rgb(255,103,0)] px-[25px] py-[10px] text-[14px] font-medium text-white hover:opacity-90"
            >
              {applyText}
            </BFLButton>
          </div>
        </div>
      </div>
    </BFLModal>
  );
};

export default FilterModal;
